"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const image_1 = __importDefault(require("next/image"));
function Image(_a) {
    var { alternativeText = '', background = false, src = '', objectFit = background ? 'cover' : undefined, objectPosition = 'center', layout = background ? 'fill' : 'responsive', className = '' } = _a, imageProps = __rest(_a, ["alternativeText", "background", "src", "objectFit", "objectPosition", "layout", "className"]);
    if (!src)
        return react_1.jsx(react_2.default.Fragment, null);
    if (typeof src === 'string' && src.includes('.s3.amazonaws.com/')) {
        const myLoader = ({ src: url, width }) => {
            const [bucket, key] = url.split('.s3.amazonaws.com/');
            const imageRequest = JSON.stringify({
                bucket: bucket.replace('https://', ''),
                edits: {
                    resize: { width },
                },
                key,
            });
            return `https://d3hj8jcbvktgwc.cloudfront.net/${Buffer.from(imageRequest).toString('base64')}?width=${width}`;
        };
        // eslint-disable-next-line no-param-reassign
        imageProps.loader = myLoader;
    }
    return (react_1.jsx("picture", { css: {
            bottom: 0,
            left: 0,
            position: background ? 'absolute' : 'relative',
            right: 0,
            top: 0,
            zIndex: background ? -2 : 0,
        }, className: className },
        react_1.jsx(image_1.default, Object.assign({ quality: 100, src: src, alt: alternativeText, objectFit: objectFit, layout: layout, objectPosition: objectPosition, css: {
                pointerEvents: 'none',
            } }, imageProps))));
}
exports.default = Image;
